import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RatesService } from '../rates.service';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
	selector: 'app-rates-edit-dialog-component',
	standalone: false,
	templateUrl: './rates-edit-dialog-component.component.html',
	styleUrl: './rates-edit-dialog-component.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatesEditDialogComponentComponent {
	constructor(
		public readonly ratesService: RatesService,
		private readonly dialogRef: DialogRef<boolean>
	) {
	}

	confirm(): void {
		this.dialogRef.close(true);
	}

	close(): void {
		this.dialogRef.close(false);
	}
}
